module.exports = __webpack_public_path__ + "static/7-ba7d09e32935ec6f2f1696797fbdbd18.jpeg";